// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3-05Y","row":"Node_row__1XTXR","label":"Node_label__2irbR","footer":"Node_footer__LWY6Y"};